export default [
  {
    list: [
      {
        subTitle: 'No-interruption power supply equipment',
        desc:
          'Data centers must always be prepared for unpredictable circumstances such as power outages, earthquakes, and flooding. DATA CENTER GAK provides uninterrupted service from any impact with a redundant configuration of the power path supplied from the external substation and the internal system.',
      },
      {
        subTitle: 'Safe, reinforced physical security system around the clock',
        desc:
          'DATA CENTER GAK, a physical security facility with the highest level of security system, is monitored in real time and access-controlled 24 hours a day, 365 days a year. In addition, it is equipped with server security diagnosis, real-time backup, and DDoS attack response system against various external attacks on its services and systems.',
      },
      {
        subTitle: 'Developed and applied the cooling system with enhanced energy efficiency and stability',
        desc:
          'DATA CENTER GAK has developed and is using a system that can air-condition the server room using natural wind for more than 80-90% of the year. It allows us to build and run this world-class, highly energy-efficient, eco-friendly data center.  Important infrastructure facilities and equipment such as power and machinery are made redundant and dualized, creating an environment that can stably run services in any emergency situation.',
      },
      {
        subTitle: 'Optimized automatic control system for reliable and efficient operation',
        desc: 'DATA CENTER GAK monitors all is facilities and manages data efficiently in an optimal environment around the clock with its integrated monitoring system.',
      },
      {
        subTitle: 'Technology that turns nature into energy',
        desc: 'Eco-friendly DATA CENTER GAK practices sustainable operations by actively utilizing the natural environment around it to generate energy.',
      },
      {
        subTitle: 'Resource recycling systems that increase eco-friendly value',
        desc: 'DATA CENTER GAK increases its eco-friendly value by recycling resources.',
      },
    ],
  },
  {
    list: [
      {
        subTitle: 'No-interruption power<br> supply equipment',
        desc:
          'Data centers must always be prepared for unpredictable circumstances such as power outages, earthquakes, and flooding. DATA CENTER GAK provides uninterrupted service from any impact with a redundant configuration of the power path supplied from the external substation and the internal system.',
        list: [
          {
            title: "Redundant power <br class='hidden-md-up' /><br class='hidden-xl-down' />supply",
            text:
              "DATA CENTER GAK, to secure a stable power supply, gets power supplied from Korea Electric Power Substation with dualized routes and redundant lines.<br/><br/> The ultra-high voltage 154 kV power line connected to GAK Sejong has a secure dual underground path all the way to the electrical room of GAK Sejong. It's also modularized to allow easy addition expansion by stages.",
            name: '',
            img: '/img/tech/safety-1-1.jpg',
          },
          {
            title: 'Uninterruptible Power<br>Supply',
            text:
              'UPS is a device that supplies power for approximately 15-20 minutes when the power is down. <br/><br/>GAK Chuncheon is equipped with dynamic UPS and GAK Sejong with static UPS. In the event of a power supply interruption or momentary outage, an induction coupling (Chuncheon) or battery (Sejong) connected to the UPS provides stable backup power for a time until the emergency generator is activated.',
            name: 'UPS(Uninterruptible Power Supply device)',
            img: '/img/tech/safety-1-2.jpg',
          },
          {
            title: 'Backup of backups, <br/>STS',
            text:
              'STS is a power switch that seamlessly switches UPS power source from the main supply to the reserve, in case of outage of the UPS power supplies the server room racks.<br/><br/> When the UPS power supply quality to the racks deteriorates (e.g., power outage, fault, interruption, etc.), it automatically switches the power source from the main to the reserve to enable stable power supply without interruption despite any external influences or changes.',
            name: 'STS(Static Transfer Switch)',
            img: '/img/tech/safety-1-3.jpg',
          },
        ],
      },
      {
        subTitle: 'Safe, reinforced physical security system around the clock',
        desc:
          'DATA CENTER GAK, a physical security facility with the highest level of security system, is monitored in real time and access-controlled 24 hours a day, 365 days a year. In addition, it is equipped with server security diagnosis, real-time backup, and DDoS attack response system against various external attacks on its services and systems.',
        list: [
          {
            title: "Building intrusion <br class='hidden-md-up'/><br class='hidden-md-down'/>detection system",
            text:
              'DATA CENTER GAK has built and is running an intrusion detection facility that detects unauthorized access.<br><br>GAK Chuncheon has a vibration detection sensor and an infrared detection sensor installed on the outer fence to detect and respond to unauthorized intrusions. The entire site is monitored 24 hours a day, 365 days a year. In GAK Sejong, any intrusion by unauthorized persons is detected and stopped with vibration detection center cables and a CCTV video analysis system installed without blind spots.',
            name: '',
            img: '/img/tech/safety-2-1.jpg',
          },
          {
            title: "Strict access <br class='hidden-sm-down' />control",
            text:
              'DATA CENTER GAK manages and records all visitor access with VMS, a data center access management system independently developed by NAVER Cloud. Access permission is granted in stages according to the security area when a visitor registers to enter the site, and a more enhanced physical security system such as card readers, biometric recognition, and man-trap is used in areas that require additional security.',
            name: 'VMS(Visitor Manager System)',
            img: '/img/tech/safety-2-2.jpg',
          },
          {
            title: "Detection and blocking of<br class='hidden-md-down' /> DDoS attacks",
            text:
              'To detect signs of various external attacks including DDoS, DATA CENTER GAK is monitoring for attacks around the clock in real time. When an attack is detected, a dedicated task force is formed immediately. We continue to improve our system to build and run an efficient response system based on the collected attack information.',
            name: '',
            img: '/img/tech/safety-2-3.jpg',
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        subTitle: 'Developed and applied the cooling system with enhanced energy efficiency and stability',
        desc:
          'DATA CENTER GAK has developed and is using a system that can air-condition the server room using natural wind for more than 80-90% of the year. It allows us to build and run this world-class, highly energy-efficient, eco-friendly data center.  Important infrastructure facilities and equipment such as power and machinery are made redundant and dualized, creating an environment that can stably run services in any emergency situation.',
        list: [
          {
            title: 'Unrivaled PUE index',
            text:
              'Indicating power efficiency, the PUE index with a value closer to 1 means the data center is more efficient.<br><br>DATA CENTER GAK maintains high energy efficiency with an annual average of 1.1x PUE.',
            name: 'PUE(Power Usage Effectiveness) Total power consumption divided by power consumption of IT equipment',
            img: '/img/tech/performance-1-1.jpg',
          },
          {
            title: 'Hybrid air conditioning <br/>system, NAMU',
            text:
              'DATA CENTER GAK has developed and is running its own server room air conditioning system, NAVER Air Membrane Unit (NAMU).<br><br>Following the 1st and 2nd generation NAMUs that actively uses outside air directly for cooling, NAMU3, a hybrid air conditioning system where you can choose whether to use cooling by indirect or direct external air has been developed and applied to GAK Sejong. This helps us with stable and efficient operation that makes the most of natural outdoor air and heat sources all year, while saving energy even more effectively.',
            name: '',
            img: '/img/tech/performance-1-2.jpg',
          },
          {
            title: 'Dualized and redundant design of cooling equipment system',
            text:
              'By applying a combination of a chilled water system using late-night electricity and a free cooling system using outside air, operational efficiency is maximized with minimal energy, and all infrastructure facilities are installed at least n+1 (spare) to enable stable cooling for the server rooms.',
            name: '',
            img: '/img/tech/performance-1-3.jpg',
          },
        ],
      },
      {
        subTitle: 'Optimized automatic control system for reliable and efficient operation',
        desc: 'DATA CENTER GAK monitors all is facilities and manages data efficiently in an optimal environment around the clock with its integrated monitoring system.',
        list: [
          {
            title: 'Proprietary infrastructure <br/>management system, <br/>DCIM',
            text:
              "To optimize the building's various energy usage and power usage efficiency (PUE), we've built and are running a data center infrastructure management system (DCIM) that lets us analyze and manage power usage trends by down to a minute and monitor all infrastructure facilities in real time.",
            name: '',
            img: '/img/tech/performance-2-1.jpg',
          },
          {
            title: "Standardized real-time <br class='hidden-md-up' />fault management <br class='hidden-md-up' />system, <br class='hidden-sm-down' />TTS",
            text: 'We utilize a proprietary TTS system that divides service failures experienced by users into five stages to quickly analyze and accurately address problematic situations.',
            name: 'TTS(Trouble Ticket System)',
            img: '/img/tech/performance-2-2.jpg',
          },
          {
            title: 'Integrated monitoring system',
            text:
              "DATA CENTER GAK's integrated monitoring system that monitors the status of all facilities, energy usage status, and various alarms at a glance improves energy efficiency and lets us quickly respond to various issues (breakdowns, unit faults, errors, etc.)",
            name: '',
            img: '/img/tech/performance-2-3.jpg',
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        subTitle: 'Technology that turns nature into energy',
        desc: 'Eco-friendly DATA CENTER GAK practices sustainable operations by actively utilizing the natural environment around it to generate energy.',
        list: [
          {
            title: 'Solar power facilities',
            text:
              "DATA CENTER GAK has solar power generation facilities installed on the building's rooftop and unused outdoor spaces to use the generated power for lighting and heating in and outside the building. This saves about 200 MWh of electricity per year and reduces carbon emissions by about 92 tons per year.",
            name: '',
            img: '/img/tech/eco-1-1.jpg',
          },
          {
            title: 'Geothermal system',
            text:
              'DATA CENTER GAK Sejong uses geothermal heat collected from the holes drilled down to 220 m underground (240 holes) as a heat source for cooling and heating of the main building. Ground heat, maintained at a constant temperature of around 15-20 degrees throughout the year, lets us efficiently utilize eco-friendly natural energy that is cool in the summer and warm in the winter.',
            name: '',
            img: '/img/tech/eco-1-2.jpg',
          },
        ],
      },
      {
        subTitle: 'Resource recycling systems <br/>that increase eco-friendly value',
        desc: 'DATA CENTER GAK increases its eco-friendly value by recycling resources.',
        list: [
          {
            title: "Waste heat recovery <br class='hidden-md-up' />units",
            text:
              "DATA CENTER GAK Sejong is run utilizing waste heat energy emitted from the server room in various ways by using a waste heat recovery system that can control the temperature of the hot air emitted from the servers.<br><br>The waste heat emitted from the servers is used for heating and hot water in the main building throughout the four seasons, and is also applied to the snow melting system to prevent the center's internal ring road from freezing during the winter, reducing electrical energy usage.",
            name: '',
            img: '/img/tech/eco-2-1.jpg',
          },
          {
            title: 'Snow melting system',
            text:
              'The floating hot water snow melting system that lets water heated by waste heat generated from the server run to hot water pipes under the road prevents freezing on the ring road and sloped roads in winter and melts snow piled up.',
            name: '',
            img: '/img/tech/eco-2-2.jpg',
          },
          {
            title: 'Water recycling system',
            text:
              "We're also making efforts to save water resources as rainwater collected on the roof is purified and recycled for the cooling tower and for landscaping, and the wastewater reclamation and reusing system treats water recovered from washbasins and showers to recycle for toilets.<br><br>This water recycling system reduces 34% of total water usage.",
            name: '',
            img: '/img/tech/eco-2-3.jpg',
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        title: 'Data<br class="hidden-md-down"> redundancy',
        body:
          'To securely store and operate user data, we use our own data storage system to replicate the data stored on the server in double or triple and distribute it to multiple servers in the data center, so that we can provide stable services even in the event of unexpected IT equipment failures or other failures.',
        name: '',
        img: '/img/tech/ft-1.jpg',
        bg: '/img/tech/ft-1-m.jpg',
      },
      {
        title: 'Disaster recovery service (DR)',
        body:
          "When the data center's IT infrastructure fails due to natural disasters, such as earthquakes or fire, or various disasters or accidents, such as terrorism, hacking, or cyber attacks, and can't perform its functions, it can be quickly replaced or restored to ensure continuity of business and services.",
        name: 'DR(Disaster Recovery)',
        img: '/img/tech/ft-2.jpg',
        bg: '/img/tech/ft-2-m.jpg',
      },
      {
        title: 'Water guns for<br class="hidden-md-down"> wildfires',
        body:
          'The water guns installed on the roofs of data center buildings are designed to spray water within a 60-meter watertight range in the event of a fire to prevent the fire from spreading to the data center.',
        img: '/img/tech/ft-3.jpg',
        bg: '/img/tech/ft-3-m.jpg',
      },
    ],
  },
];
